import React from "react";
import { stepSixData } from "./stepData";
import { Typography } from "@mui/material";

const StepSix = () => {
  return (
    <>
      <div>
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepSixData[0].heading}
          </Typography>

          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              letterSpacing: "0.08px",
              fontWeight: 500,
              fontFamily: "'Archivo',sans-serif",
            }}
          >
            The <strong>Annual Percentage Rate (APR)</strong> offers a more
            complete picture of the total cost of your loan, factoring in both
            the interest rate and additional fees like processing charges. By
            comparing APRs across different loan offers, you can make more
            informed decisions about which loan is most cost-effective.
          </Typography>
        </div>
      </div>
    </>
  );
};

export default StepSix;
